export * from './public_api';
export { _firebaseAppFactory as ɵa } from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angularfire2/index.js
// module id = ../../../../angularfire2/index.js
// module chunks = 7